
document.addEventListener('DOMContentLoaded', function () {
    const button = document.getElementById('generate-song');
    const previewContainer = document.querySelector('.song-preview-container');
    const errorBox = document.createElement('div');
    previewContainer.parentNode.insertBefore(errorBox, previewContainer);
    const addToCart = document.getElementById('song_add_cart');

    const relationshipSelect = document.getElementById('relationship-select');
    const otherWrapper = document.getElementById('other-relationship-wrapper');

    relationshipSelect.addEventListener('change', function () {
        if (this.value === 'Sonstiges') {
            otherWrapper.style.display = 'block';
        } else {
            otherWrapper.style.display = 'none';
        }
    });

    button.addEventListener('click', async (e) => {
        e.preventDefault();
        errorBox.innerHTML = ''; // Fehler zurücksetzen

        const task_id = document.getElementById('task_id');

        const span = this.querySelector('.btn_text');
        const loader = button.querySelector('.loading-overlay__spinner');

        const form = document.getElementById('songForm');

        if (!form.checkValidity()) {
            form.reportValidity(); // shows browser validation messages
            return; // stop execution until valid
        }

        // Collect form data
        const formData = new FormData(form);
        const data = {};
        formData.forEach((value, key) => {
            if (data[key]) {
            if (!Array.isArray(data[key])) data[key] = [data[key]];
            data[key].push(value);
            } else {
            data[key] = value;
            }
        });

        // Hide span
        span.classList.add('hidden');
        // Show loader
        loader.classList.remove('hidden');
        button.setAttribute('disabled', 'disabled');

        try {
            const song_res = await fetch('https://song.buch-glueck.de/api/generate-song', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data),
            });

            const song_ress = await song_res.json();
            console.log(song_ress, '-----------parsed response');

            if (song_ress.success) {
            // Backend alle 5s pollen, bis der Song bereit ist
            let taskId = song_ress.job.task_id;

            task_id.value = taskId;

            const interval = setInterval(async () => {
                try {
                    const res = await fetch('https://song.buch-glueck.de/api/musicgpt/last', {
                        method: 'GET',
                        headers: { 'Content-Type': 'application/json' },
                    });

                    const result = await res.json();
                    console.log(result, '-----------result');

                    if (result.audio) {
                        let lyricsText = 'Kein Songtext für die Vorschau gefunden.';

                        if (Array.isArray(result.lyrics)) {
                            lyricsText = result.lyrics.map((line) => line.text).join('\n');
                        } else if (typeof result.lyrics === 'string') {
                            lyricsText = result.lyrics;
                        }

                        // Elemente auswählen und befüllen
                        const audioPlayer = document.querySelector('.song-preview-audio audio');
                        const lyricsBox = document.getElementById('lyrics-content');

                        if (audioPlayer) {
                            audioPlayer.src = result.audio;
                            audioPlayer.load();
                        }

                        if (lyricsBox) {
                            lyricsBox.innerText = lyricsText;
                        }

                        if (previewContainer) {
                            previewContainer.style.display = 'block';
                            previewContainer.scrollIntoView({ behavior: 'smooth' });
                        }

                        span.classList.remove('hidden');
                        loader.classList.add('hidden');
                        button.removeAttribute('disabled');

                        clearInterval(interval);
                    }
                } catch (pollErr) {
                    console.error('Fehler beim Polling:', pollErr);
                }
            }, 5000);
            } else {
                span.classList.remove('hidden');
                loader.classList.add('hidden');
                button.removeAttribute('disabled');
                
                errorBox.innerHTML = `<span style="color:red;">${
                    song_ress?.error || 'Fehler beim Generieren des Songs. Bitte versuche es erneut.'
                }</span>`;
            }
        } catch (err) {
            span.classList.remove('hidden');
            loader.classList.add('hidden');
            button.removeAttribute('disabled');
            console.error(err);
            errorBox.innerHTML = `<span style="color:red;">${
            err?.response?.data?.message?.detail ||
            err?.response?.data?.error ||
            'Fehler beim Generieren des Songs. Bitte versuche es erneut.'
            }</span>`;
        }
    });

    addToCart.addEventListener('click', async (e) => {
        try {
            const task_id = document.getElementById('task_id').value;
            const VariantId = document.getElementById('variantIID').value;
            const formData = {
            items: [
                {
                    id: VariantId, // sicherstellen, dass die Variant-ID korrekt ist
                    quantity: 1,
                    properties: {
                    _taskId: task_id,
                    },
                },
            ],
            };

            const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData),
            });

            console.log('Zum Warenkorb hinzugefügt:', response);

            if (!response.ok) {
                throw new Error("Fehler beim Hinzufügen zum Warenkorb");
            }else{
                // Weiterleitung zum Warenkorb
               
                window.location.href = 'https://buch-glueck.de/cart';

            }
            
        } catch (error) {
            console.error('Fehler beim Hinzufügen zum Warenkorb:', error);
        }
    });
});
